module.exports = __webpack_public_path__ + "img/ic-close-circle-white.4462b866.svg";